<template>
  <b-card>
    <div
      class="table-header-border-bottom pb-1 mb-md-3 d-flex justify-content-between align-items-center"
    >
      <h3 class="mt-1">
        <feather-icon
          icon="FileTextIcon"
          class="mr-50"
          style="width: 18px; height: 18px"
        />
        <span>Documents</span>
      </h3>
      <!-- <div class="d-flex">
        <b-button class="gradient-btn mt-1" :to="{ name: 'documents-create' }">
          <feather-icon icon="PlusIcon" />
          Create documents
        </b-button>
      </div> -->
    </div>
    <b-form
      @submit.prevent="filter"
      class="filters rounded p-1 my-md-1 d-flex align-items-center justify-content-between flex-wrap"
    >
      <div class="col-sm-3 col-12 p-50 d-flex align-items-center">
        <!-- <div class="mr-50">
            <b-form-checkbox v-model="selectAll"></b-form-checkbox>
          </div> -->
        <v-select
          :options="types"
          v-model="type"
          label="label"
          :reduce="(option) => option.value"
          :searchable="false"
          placeholder="Display on the page"
          class="w-100"
        ></v-select>
      </div>

      <div class="col-sm-6 col-12 d-flex align-items-center flex-wrap p-50">
        <template v-if="type == 'model'">
          <div class="col-md-6 col-12 py-50 px-sm-50 px-0">
            <select-box
              v-model="model_type"
              class="w-100"
              searchable
              :lists="['user', 'partner']"
            />
          </div>
          <div class="col-md-6 col-12 py-50 px-sm-50 px-0">
            <select-box
              v-model="model_id"
              label="text"
              class="w-100"
              select="id"
              searchable
              :url="model_type"
            />
          </div>
        </template>

        <b-form-input
          v-else
          placeholder="search"
          v-model.trim="search"
          :disabled="!type"
        />
      </div>
      <div class="col-sm-3 col-12 p-50">
        <b-button
          class="w-100"
          type="submit"
          :disabled="!search && !(!search && model_type && model_id)"
        >
          <span class="text-muted h5"> Filtering</span>
        </b-button>
      </div>
    </b-form>
    <data-table :fields="fields" :items="documents" :loading="loading">
      <template #row="{ data }">
        <div class="d-flex">
          <div class="pr-1 border-right">
            <span class="font-weight-bold h5 mb-0">{{ data.item.id }}</span>
          </div>
        </div>
      </template>
      <template #model="{ data }">
        <span class="text-white" style="white-space: nowrap">{{
          hasOwnNestedProperty(data.item, "model.data.name")
            ? data.item.model_type + "-" + data.item.model.data.name
            : hasOwnNestedProperty(data.item, "model.data.first_name")
            ? data.item.model_type +
              "-" +
              data.item.model.data.first_name +
              " " +
              data.item.model.data.last_name
            : "-"
        }}</span>
      </template>
      <template #reason="{ data }">
        <span class="text-truncate mb-0">
          {{ data.item.reason || "-" }}
        </span>
      </template>
      <template #status="{ data }">
        <b-badge
          class="p-75"
          :class="
            data.item.status === 'PENDING'
              ? 'bg-warning'
              : data.item.status === 'ACCEPTED'
              ? 'bg-success'
              : 'bg-danger'
          "
        >
          {{ data.item.status }}
        </b-badge>
      </template>
      <template #type="{ data }">
        <span>
          {{ data.item.type || "-" }}
        </span>
      </template>
      <!-- 
      <template #actions="{ data }">
        <div class="nowrap-white-space">
          <b-dropdown no-caret class="d-flex d-xl-none more-option">
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" />
            </template>
            <b-dropdown-item
              variant="flat-primary"
              :to="{
                name: 'documents-edit',
                params: {
                  id: data.item.id,
                },
              }"
            >
              <div class="d-flex align-items-center w-100">
                <feather-icon icon="EditIcon" class="mr-50" />Edit
              </div>
            </b-dropdown-item>
          </b-dropdown>
          <div class="d-xl-flex d-none">
            <b-button
              variant="flat-primary"
              size="sm"
              :to="{
                name: 'documents-edit',
                params: {
                  id: data.item.id,
                },
              }"
              ><feather-icon icon="EditIcon" />Edit</b-button
            >
          </div>
        </div>
      </template> -->
    </data-table>

    <div
      class="w-100 d-flex flex-wrap align-items-center justify-content-between"
    >
      <b-pagination
        v-model="currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        size="lg"
        pills
        class="my-2 d-flex justify-content-center"
      >
      </b-pagination>
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BPagination,
  BLink,
  BCard,
  BFormCheckbox,
  BForm,
  BFormInput,
  BBadge,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VSelect from "vue-select";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import qs from "qs";
export default {
  components: {
    DataTable,
    BButton,
    BModal,
    BCard,
    VBModal,
    BPagination,
    BLink,
    BFormCheckbox,
    BForm,
    BFormInput,
    BBadge,
    VSelect,
    SelectBox,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      url: "/panel/documents",
      currentPage: 1,
      loading: false,
      pagination: {},
      pages: [],
      selectedPage: "",
      types: [
        // { label: "Name", value: "name" },
        { label: "Status", value: "status" },
        { label: "Type", value: "type" },
        // { label: "Model", value: "model" },
      ],
      type: "",
      search: "",
      model_type: "",
      model_id: "",
      fields: [
        { key: "row", label: "row" },
        { key: "model", label: "user" },
        { key: "reason", label: "reason" },
        { key: "status", label: "status" },
        { key: "type", label: "type" },
        // { key: "actions", label: "operation" },
      ],
      documents: [],
    };
  },
  directives: {
    "b-modal": VBModal,
  },
  watch: {
    search(val) {
      if (!val) {
        if (this.$route.query.filter) {
          this.$router.push({
            name: "documents",
          });
        }
      }
    },
    async type(newVal, oldVal) {
      if (oldVal) {
        this.search = await "";
        if (this.$route.fullPath != "/documents") {
          this.$router.push({
            name: "documents",
          });
        }
      }
    },
    currentPage(val) {
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "documents",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    $route: {
      handler(val) {
        this.getDocuments();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    if (this.$route.query && this.$route.query.filter) {
      Object.keys(this.$route.query.filter).map((key) => {
        this.type = key;
        if (key == "model") {
          this.model_type = this.$route.query.filter[key].type;
          this.model_id = this.$route.query.filter[key].id;
        } else {
          this.search = this.$route.query.filter[key];
        }
      });
    }
  },
  methods: {
    filter() {
      if (this.type) {
        let filter = {};
        if (this.type == "model") {
          filter = {
            model: {
              type: this.model_type,
              id: this.model_id,
            },
          };
        } else {
          filter[this.type] =
            this.type == "status" ? this.search.toUpperCase() : this.search;
        }
        this.$router.push({
          name: "documents",
          query: {
            ...this.$route.query,
            filter,
          },
        });
      } else if (this.$route.fullPath != "/documents") {
        this.$router.push({
          name: "documents",
        });
      }
    },
    async getDocuments() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        const { data } = await this.$http.get(this.url, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.documents = data.data;
        this.pagination = await data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>

<style scoped>
@media (max-width: 576px) {
  [dir] .btn {
    padding: 14px 5px;
    font-size: 12px;
  }
  h3 {
    font-size: 15px !important;
  }
}
</style>
